import React from "react";
import RequestsPage from "../RequestsPage";

export default function ProviderRequests() {
  return <RequestsPage role="provider" />;
}
